export default __webpack_public_path__ + "static/media/utilitalia-logo.43b62f57.png";